import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setUsername, setUserIdStore,setClientId } from "../../Redux/store/userSlice";
import { useToast } from "../../Utils/toastContext";
import { setApplicationType } from "../../Redux/store/accountTypeSlice";
import { changeCardFalse } from "../../Redux/store/selectedCard";
import { syncAccountRestriction } from "../../Utils/syncAccountRestriction";
import { resetPlatformNoticeSession } from "../../Utils/platformNoticeSession";

const WebSocketComponent = ({ userId }) => {
  const WS_URL = process.env.REACT_APP_WS_URL;
  const { showToast } = useToast();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const socket = new WebSocket(WS_URL);

    socket.onopen = () => {
      console.log("WebSocket connected");
      socket.send(JSON.stringify({ type: "auth", user_id: userId }));
    };

    socket.onmessage = (event) => {
      console.log("Raw WebSocket message received:", event.data);
      try {
        const data = JSON.parse(event.data);
        console.log("Parsed WebSocket data:", data);

        if (data.event === "auth_code_verified") {
          setLoading(true);
          dispatch(setUsername(data.data.name));
          dispatch(setUserIdStore(data.data.user_id));
          localStorage.setItem("jwtToken", data.data.access_token);
          localStorage.setItem("refreshJwtToken", data.data.refresh_token);
          localStorage.setItem("systemToken", data.data.session_id);
          syncAccountRestriction(dispatch, data.data);
          resetPlatformNoticeSession();
          const savedRedirect = sessionStorage.getItem("redirectAfterLogin");
          setTimeout(() => {
            setLoading(false);
            dispatch(changeCardFalse());
            if (savedRedirect) {
              const { path, state } = JSON.parse(savedRedirect);
              navigate(path, { state });
              sessionStorage.removeItem("redirectAfterLogin"); // prevent reuse
            } else {
                localStorage.setItem("sideOption", 1);
                let redirectState = {
                  path: "/",
                  state: {
                    from: location.pathname,
                    historyStack: [
                      ...(location.state?.historyStack || []),
                      location.pathname,
                    ],
                  },
                };
                sessionStorage.setItem(
                  "redirectAfterLogin",
                  JSON.stringify(redirectState)
                );
                navigate("/"); // default dashboard
            }
          }, 1000);
        }
      } catch (error) {
        showToast(error.message, "error");
      }
    };

    socket.onerror = (error) => {
      showToast(error.message, "error");
    };

    socket.onclose = () => {
      console.log("WebSocket disconnected");
    };

    return () => {
      socket.close();
    };
  }, [userId]); // Re-run effect if userId changes

  return (
    <div className="">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

export default WebSocketComponent;
